import { 
  UserCircle,
  CheckCircle,
  CalendarCheck,
  Storefront,
  Pill
} from '@phosphor-icons/react';

export default function CMACheckoutModal({
  isOpen,
  onClose,
  onBack,
  onSend,
  cmaInstructions,
  setCmaInstructions,
  cmaCheckoutLoading,
  cmaCheckoutSent
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 overflow-y-auto">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-lg p-6 m-4 my-8" data-testid="cma-checkout-modal">
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <UserCircle size={32} className="text-blue-600" weight="fill" />
          </div>
          <h3 className="text-xl font-semibold text-slate-900">Send to CMA Checkout</h3>
          <p className="text-slate-500 mt-2">
            Add instructions for the CMA to complete checkout tasks
          </p>
        </div>

        {cmaCheckoutSent ? (
          <div className="text-center">
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
              <CheckCircle size={24} className="text-green-600 mx-auto mb-2" weight="fill" />
              <p className="text-green-700 font-medium">Patient Sent to CMA Queue!</p>
              <p className="text-green-600 text-sm mt-1">
                CMA will complete checkout and finalize the AVS
              </p>
            </div>
            <button
              onClick={onClose}
              className="w-full btn-teal"
              data-testid="cma-checkout-done-btn"
            >
              Done - Return to Dashboard
            </button>
          </div>
        ) : (
          <div className="space-y-4">
            {/* Return Visit */}
            <div>
              <label className="label-clinical text-sm flex items-center gap-2">
                <CalendarCheck size={16} />
                Return Visit
              </label>
              <select
                value={cmaInstructions.return_visit}
                onChange={(e) => setCmaInstructions(prev => ({ ...prev, return_visit: e.target.value }))}
                className="input-clinical w-full"
                data-testid="cma-return-visit"
              >
                <option value="">Select timeframe...</option>
                <option value="1 week">1 week</option>
                <option value="2 weeks">2 weeks</option>
                <option value="1 month">1 month</option>
                <option value="6 weeks">6 weeks</option>
                <option value="3 months">3 months</option>
                <option value="6 months">6 months</option>
                <option value="1 year">1 year (annual)</option>
                <option value="As needed">As needed</option>
              </select>
            </div>

            {/* Scheduling Needs */}
            <div>
              <label className="label-clinical text-sm">Scheduling Needs</label>
              <input
                type="text"
                value={cmaInstructions.scheduling_needs}
                onChange={(e) => setCmaInstructions(prev => ({ ...prev, scheduling_needs: e.target.value }))}
                placeholder="E.g., Schedule cardiology referral, book lab work..."
                className="input-clinical w-full"
                data-testid="cma-scheduling-needs"
              />
            </div>

            {/* Pharmacy Verification */}
            <div>
              <label className="label-clinical text-sm flex items-center gap-2">
                <Storefront size={16} />
                Pharmacy Verification
              </label>
              <input
                type="text"
                value={cmaInstructions.pharmacy_verification}
                onChange={(e) => setCmaInstructions(prev => ({ ...prev, pharmacy_verification: e.target.value }))}
                placeholder="E.g., Verify CVS has medication in stock..."
                className="input-clinical w-full"
                data-testid="cma-pharmacy-verification"
              />
            </div>

            {/* Medication Follow-up */}
            <div>
              <label className="label-clinical text-sm flex items-center gap-2">
                <Pill size={16} />
                Medication / Refill Follow-up
              </label>
              <input
                type="text"
                value={cmaInstructions.medication_followup}
                onChange={(e) => setCmaInstructions(prev => ({ ...prev, medication_followup: e.target.value }))}
                placeholder="E.g., Confirm patient understands dosing instructions..."
                className="input-clinical w-full"
                data-testid="cma-medication-followup"
              />
            </div>

            {/* Additional Notes */}
            <div>
              <label className="label-clinical text-sm">Additional Notes</label>
              <textarea
                value={cmaInstructions.additional_notes}
                onChange={(e) => setCmaInstructions(prev => ({ ...prev, additional_notes: e.target.value }))}
                placeholder="Any other instructions for the CMA..."
                className="input-clinical w-full"
                rows={2}
                data-testid="cma-additional-notes"
              />
            </div>

            <div className="pt-4 space-y-3">
              <button
                onClick={onSend}
                disabled={cmaCheckoutLoading}
                className="w-full btn-teal flex items-center justify-center gap-2"
                data-testid="confirm-send-to-cma-btn"
              >
                {cmaCheckoutLoading ? (
                  <>
                    <div className="spinner" /> Sending...
                  </>
                ) : (
                  <>
                    <UserCircle size={18} />
                    Send to CMA Checkout Queue
                  </>
                )}
              </button>
              <button
                onClick={onBack}
                className="w-full btn-outline"
                data-testid="back-to-avs-btn"
              >
                Back to AVS Options
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
